// @core/api/endpoints/booking/list_provider_bookings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBookingsResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * List provider bookings
 * Returns bookings for resources owned by the current user. Provider-facing schedule and dashboard.
 */
export async function ListProviderBookings(
  params?: {
    cursor?: string | number | boolean;
    date_from?: string | number | boolean;
    date_to?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    resource_id?: string | number | boolean;
    sort?: string | number | boolean;
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListBookingsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/bookings/provider`;
  const requestOptions = options;
  return client.get<ListBookingsResponse>(requestPath, { ...requestOptions, params });
}
